import { forwardRef, useEffect, useRef, useState } from "react";
import { CreateManualAccountconfig, CreateManualAccountData } from "../Data/CreateManualAccount.data";
import FormCreator from "../../../components/Forms/FormCreator";
import MolGrid from "../../../components/Grid/MolGrid";
import Buttons from "../../../components/ui/button/Buttons";
import { useLazyGetAllDropDownsForMemberDirectoryQuery, useLazyGetPDFQuery, useStoreBase64ImageMutation, useUploadPDFMutation } from "../../../app/services/common/commonApi";
import { setDropDownField } from "../utils/setFieldParameter";
import { useAddManualAccountMutation } from "../../../app/services/GMAP/gmapApplicationTaskListApi";
import ToastService from "../../../services/toastService/ToastService";
import SwalAlert from "../../../services/swalService/SwalService";
import { APIUrl } from "../../../utils/API/fetchBaseQuery";
import { useNavigate } from "react-router-dom";

const CreateManualGmp = forwardRef((props, ref) => {
    const createManualAccountRef = useRef();
    const documentGridRef = useRef();

    const calculateValidToDate = (selectedValidFrom) => {
        if (!selectedValidFrom) return "";
        const selectedDate = new Date(selectedValidFrom);
        const year = selectedDate.getFullYear();
        const june30 = new Date(year, 5, 31);

        let validToDate;
        if (selectedDate <= june30) {
            validToDate = new Date(year + 1, 5, 31);
        } else {
            validToDate = new Date(year + 2, 5, 31);
        }
        return validToDate.toISOString().split("T")[0];
    };

    const [formData, setFromData] = useState(CreateManualAccountData)
    const [dataSource, setDataSource] = useState([]);
    const { error } = SwalAlert();
    const navigate = useNavigate();
    const [getAllDropDownsForManualAccount, {
        isLoading: isDropdownLoading,
        isSuccess: isDropdownSuccess,
        data: apiResponse,
    }] = useLazyGetAllDropDownsForMemberDirectoryQuery();

    const [uploadPDF, {
        isSuccess: isFileSuccess,
        isLoading: isFileLoading,
        data: uploadFileResponse
    },] = useUploadPDFMutation();

    const [saveMainImage, { isSuccess: isSuccessImage, isLoading: isLoadingImage, data: profileImageUpload }] = useStoreBase64ImageMutation();

    const [addManualAccount, {
        isSuccess: isAddManualAccountSuccess,
        isLoading: isAddManualAccountLoading,
        data: addManualAccountData
    }] = useAddManualAccountMutation();

    useEffect(() => {
        getAllDropDownsForManualAccount();
    }, [isDropdownLoading, isDropdownSuccess, apiResponse])

    useEffect(() => {
        if (!isDropdownLoading && isDropdownSuccess && apiResponse) {
            setDropDownField(apiResponse);
        }
    })

    useEffect(() => {
        if (!isLoadingImage && isSuccessImage && profileImageUpload) {
            ToastService.success("Image uploaded successfully !")
            const updatedDataSource = [...dataSource];
            updatedDataSource.push({
                uploadedFileName: profileImageUpload?.fileName || "File Name",
                fileName: profileImageUpload?.uploadedFileName || "File Name",
                certificateLink: `${APIUrl}/Common/getPDF?type=AttendanceCert&fileName=${profileImageUpload.fileName}`          
            });
            setDataSource(updatedDataSource);
        }
    }, [isLoadingImage, isSuccessImage, profileImageUpload,]);

    useEffect(() => {
        if (!isAddManualAccountLoading && isAddManualAccountSuccess && addManualAccountData) {
            
            if (addManualAccountData?.primaryEmail === 'System has found a matching primary email address record already in use') {
                ToastService.error('System has found a matching primary email address record already in use');
            }
            else {
                ToastService.success("Create Manual account successfuly.")
                navigate("/viewManualAccountList");
            }
        }
    }, [isAddManualAccountSuccess, isAddManualAccountLoading, addManualAccountData]);

    useEffect(() => {
        if (!isFileLoading && isFileSuccess && uploadFileResponse) {
            const updatedDataSource = [...dataSource];
            updatedDataSource.push({
                uploadedFileName: uploadFileResponse?.fileName || "File Name",
                fileName: uploadFileResponse?.uploadedFileName || "File Name",
                certificateLink: `${APIUrl}/Common/getPDF?type=AttendanceCert&fileName=${uploadFileResponse.fileName}`
                // filePath: uploadFileResponse?.filePath || "",
            });
            setDataSource(updatedDataSource);

            if (updatedDataSource.length >= 3) {
                setFromData(prevState => {
                    const updatedFields = prevState.formFields.map(field => {
                        if (field.dataField === "UploadFile") {
                            return {
                                ...field,
                                fieldSetting: {
                                    ...field.fieldSetting,
                                    isDisable: true,
                                },
                            };
                        }
                        return field;
                    });

                    return {
                        ...prevState,
                        formFields: updatedFields,
                    };
                });
            }
        }
    }, [isFileLoading, isFileSuccess, uploadFileResponse]);

    const handleFormFieldChange = (dataField, value, updatedData) => {

        if (dataField === "validFrom") {
            const calculatedValidTo = calculateValidToDate(value);
            setFromData(prevState => ({
                ...prevState,
                initialState: {
                    ...updatedData,
                    validFrom: value,
                    Validto: calculatedValidTo,
                }
            }));
        }
        else if (dataField === "UploadFile" && value) {
            if (value.type === "application/pdf") {
                handleOnChangeFileUpload(value)
                setFromData(prevState => ({
                    ...prevState,
                    initialState: {
                        ...updatedData,
                        fileName: updatedData?.UploadFile?.name || "",
                        UploadFile: null,
                    }
                }));
            }
            else {
                handleOnChangeImageUpload(value);
                setFromData(prevState => ({
                    ...prevState,
                    initialState: {
                        ...updatedData,
                        fileName: updatedData?.UploadFile?.fileName || "",
                        UploadFile: null,
                    }
                }));
            }
        }
        else {
            setFromData(prevState => ({
                ...prevState,
                initialState: {
                    ...updatedData,
                    [dataField]: value
                }
            }));
        }
    };

    const handleOnChangeFileUpload = async (data) => {
        let formData = new FormData();
        formData.append("file", data)
        formData.append("storagePath", "AttendanceCert");
        uploadPDF(formData);
    }

    const handleOnChangeImageUpload = (data) => {
        const { base64Data, fileName } = data
        let saveFileRequest = {
            fileName: fileName,
            fileStr: base64Data,
            storagePath: "AttendanceCert",
        }
        saveMainImage(saveFileRequest)
    }

    const handleBack = () => {
        navigate("/viewManualAccountList");
    };

    const handleSave = () => {
        
        const addDocuments = dataSource.map(file => ({

            gmapMemberId: 0,
            documentProof: file.uploadedFileName,
            documentProofName: file.fileName
        }));
        const formData = createManualAccountRef?.current.getFormData();
        if (!formData) {
            return error("Please fill all mandatory fields.", "");
        }

        let request = {
            FullName: formData?.name || null,
            PrimaryName: formData?.email || null,
            GMAPTier: formData?.gMPTier?.value || formData?.gMPTier,
            ValidFrom: formData?.validFrom || null,
            ValidTo: formData?.Validto || null,
            IsAppeal: formData?.Appeal || null,
            IsGmaCourseMembers: formData?.Transitioning || null,
            IsTransitioning: formData?.Distinguished || null,
            IsDistinguished: formData?.GMACourse || null,
            ManualInternalNotes: formData?.InternalNotes || null,
            AddDocuments: addDocuments,
            CertificatePath: null,
        };
        addManualAccount(request);
    };

    return (
        <>
            <div className="row form-card">
                <FormCreator
                    ref={createManualAccountRef}
                    {...formData}
                    onFormFieldValueChange={handleFormFieldChange}
                />

                <MolGrid
                    ref={documentGridRef}
                    configuration={CreateManualAccountconfig}
                    dataSource={dataSource}
                    allowPagination={false}
                />
            </div>
            <div className="tab-content mt-4">
                <div className="col-lg-12 edit-profile-tab-button d-flex justify-content-between">
                    <Buttons
                        buttonText="Back"
                        buttonTypeClassName="black-btn"
                        onClick={handleBack}
                    />
                    <Buttons
                        buttonText="Submit"
                        buttonTypeClassName="success-btn mx-4"
                        onClick={handleSave}
                        isLoading={isAddManualAccountLoading}
                    />
                </div>
            </div>
        </>
    );
});

export default CreateManualGmp;
